const ACE_KEYS = {
  homepage: {
    amenities: {
      headingKey: 'A1AA95B99F'
    },
    hotel: {
      signedInSubHeadingKey: '37BBA39836',
      signedOutHeadingKey: '39D8A99EAD',
      signedOutSubHeadingKey: '83AAD9AC5C'
    },
    vip: {
      defaultHeadingKey: '904AD09CBE',
      withNameHeadingKey: 'CBF880BFCA',
      promo: {
        headline: '209A99E911',
        headlineWithName: '82B9E988BC'
      }
    }
  }
} as const

export default ACE_KEYS
